var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChestE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 181,
    viewBox: "0 0 212 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1992 6.241C71.4221 5.4244 73.0478 5.41486 74.9801 5.91254C75.921 18.3256 87.6617 24.986 106.088 24.986C124.321 24.986 136.106 18.467 137.272 6.30527C138.432 5.70643 141.515 5.38483 142.789 6.65414C142.789 6.65737 142.789 6.66059 142.789 6.66381C151.326 9.4449 159.892 12.3772 167.256 14.8982C170.616 16.0485 173.727 17.1133 176.47 18.0389C192.387 23.4102 201.959 68.1353 205.64 99.0199C201.153 103.513 188.813 109.059 164.672 109.059C164.672 111.295 164.614 127.995 164.556 144.771L164.556 144.782L164.556 144.827C164.497 161.736 164.439 178.707 164.439 181H106.001H47.7224C47.7224 178.705 47.6099 161.814 47.4979 144.994L47.4979 144.99C47.3869 128.314 47.2763 111.709 47.2763 109.472C23.1357 109.472 10.8482 103.513 6.36133 99.0199C10.0429 68.1353 19.6142 23.4102 35.5321 18.0389C38.275 17.1133 41.3849 16.0487 44.745 14.8985C52.3933 12.2802 61.3377 9.21825 70.1995 6.34283C70.1993 6.30891 70.1992 6.27496 70.1992 6.241Z",
    fill: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_725_49005",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 200,
    height: 177
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1992 6.24148C71.4221 5.42489 73.0478 5.41534 74.9801 5.91303C75.921 18.326 87.6617 24.9865 106.088 24.9865C124.321 24.9865 136.106 18.4675 137.272 6.30576C138.432 5.70692 141.515 5.38532 142.789 6.65463C142.789 6.65785 142.789 6.66108 142.789 6.6643C151.326 9.44539 159.892 12.3777 167.256 14.8987C170.616 16.049 173.727 17.1138 176.47 18.0394C192.387 23.4107 201.959 68.1358 205.64 99.0204C201.153 103.513 188.813 109.059 164.672 109.059C164.672 111.296 164.614 127.996 164.556 144.771L164.556 144.783L164.556 144.827C164.497 161.737 164.439 178.707 164.439 181.001H106.001H47.7224C47.7224 178.705 47.6099 161.814 47.4979 144.995L47.4979 144.991C47.3869 128.315 47.2763 111.709 47.2763 109.473C23.1357 109.473 10.8482 103.513 6.36133 99.0204C10.0429 68.1358 19.6142 23.4107 35.5321 18.0394C38.275 17.1138 41.3849 16.0492 44.745 14.899C52.3933 12.2807 61.3377 9.21874 70.1995 6.34332C70.1993 6.3094 70.1992 6.27545 70.1992 6.24148Z",
    fill: "#D3D3D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_725_49005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 -5H81V181H61V-5Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 -3H153V181H133V-3Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 -3H190V181H170V-3Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 -3H43V181H23V-3Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7422 23.9053H117.258V181H96.7422V23.9053Z",
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestE);
export default __webpack_public_path__ + "static/media/Chest E.1b87f3becc056e2044ae78f54206a496.svg";
export { ForwardRef as ReactComponent };